module.exports = __webpack_public_path__ + "static/media/Prompt-Thin.ddcfbf89.ttf";